import type React from "react"

/**
 * React bubbles key events from a portal through the component tree, not the
 * DOM, so a drawer opened from an inline-edit row hands its Enter to that
 * row's commit handler: the row saves and the drawer disappears mid-typing.
 * Only Enter stops here — Escape and Tab still reach the drawer's own handlers.
 */
export function KeepEnterInside({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="contents"
      onKeyDown={(event) => {
        if (event.key === "Enter") event.stopPropagation()
      }}
    >
      {children}
    </div>
  )
}
